import script from "./CPagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./CPagination.vue?vue&type=script&setup=true&lang=ts"

import "./CPagination.vue?vue&type=style&index=0&id=f9277cfe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9277cfe"]])

export default __exports__